import React, { useState } from "react";
import StepNavigation from "./StepNavigation";
import { useTranslation } from "react-i18next";
import { toGel } from "../../config/currency";

const PROJECT_TYPES = [
  "project_type_nonstandard",
  "project_type_tukhareli",
  "project_type_italian_courtyard",
  "project_type_leningrad",
  "project_type_moscow",
  "project_type_lvov",
  "project_type_city",
  "project_type_kavlashvili",
  "project_type_czech",
  "project_type_khrushov",
  "project_type_dormitory",
  "project_type_duplex",
  "project_type_triplex",
];

export default function StepPriceAreaProject({
  listing,
  setListing,
  onBack,
  onNext,
}) {
  const { t } = useTranslation();

  const [currency, setCurrency] = useState(listing.currency || "GEL");

  const showProjectTypes = listing.type !== "land";

const YARD_TYPES = ["house", "country_house", "commercial_space", "hotel"];
const showYardArea = YARD_TYPES.includes(listing.type);

const isNextDisabled =
  !listing.price ||
  Number(listing.price) <= 0 ||
  !listing.area ||
  Number(listing.area) <= 0 ||
  (showProjectTypes && !listing.projectType);


  const handleNext = () => {
    const numericPrice = Number(listing.price);
    const numericArea = Number(listing.area);
const numericYard = Number(listing.yardArea);
    /* ---- VALIDATION ---- */
    if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
      alert("Valid price is required");
      return;
    }


if (
  listing.yardArea !== null &&
  listing.yardArea !== "" &&
  (!Number.isFinite(numericYard) || numericYard < 0)
) {
  alert("Yard area must be valid");
  return;
}

    if (!Number.isFinite(numericArea) || numericArea <= 0) {
      alert("Valid area is required");
      return;
    }

    /* ---- NORMALIZATION ---- */
    const priceGel = Math.round(toGel(numericPrice, currency));

    const updatedListing = {
      ...listing,
      price: numericPrice,
      price_gel: priceGel,
      area: numericArea,
      currency,
    };

    /* ---- COMMIT STATE ---- */
    setListing(updatedListing);

    /* ---- MOVE FORWARD USING REAL DATA ---- */
    onNext(updatedListing);
  };

  return (
    <div className="step">
      <h2>{t("price_and_area")}</h2>

      {/* PRICE */}
      <label>{t("price")}<span className="required">*</span></label>
      <div className="price-row">
        <input
          type="number"
          min="1"
          step="1"
          value={listing.price ?? ""}
          onChange={(e) =>
            setListing((l) => ({
              ...l,
              price: e.target.value,
            }))
          }
        />

        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
        >
          <option value="GEL">GEL ₾</option>
          <option value="USD">USD $</option>
        </select>
      </div>


<div className="checkbox-group">
  <label className="checkbox">
    <input
      type="checkbox"
      checked={listing.priceNegotiable || false}
      onChange={(e) =>
        setListing({
          ...listing,
          priceNegotiable: e.target.checked,
        })
      }
    />
    {t("leasting.priceNegotiable")}
  </label>

  <label className="checkbox">
    <input
      type="checkbox"
      checked={listing.exchangePossible || false}
      onChange={(e) =>
        setListing({
          ...listing,
          exchangePossible: e.target.checked,
        })
      }
    />
    {t("leasting.exchangePossible")}
  </label>

  <label className="checkbox">
    <input
      type="checkbox"
      checked={listing.bankPayment || false}
      onChange={(e) =>
        setListing({
          ...listing,
          bankPayment: e.target.checked,
        })
      }
    />
    {t("leasting.bankPayment")}
  </label>
</div>


      {/* AREA */}
      <div style={{ marginBottom: 16 }}>
        <label>
          {t("area_m2")}<span className="required">*</span>
          <input
            type="number"
            min="1"
            step="1"
            value={listing.area ?? ""}
            onChange={(e) =>
              setListing((l) => ({
                ...l,
                area: e.target.value,
              }))
            }
          />
        </label>
      </div>


{/* YARD AREA */}
{showYardArea && (
  <div style={{ marginBottom: 16 }}>
    <label>
      {t("yard_area_m2")}
      <input
        type="number"
        min="0"
        step="1"
        value={listing.yardArea ?? ""}
        onChange={(e) =>
          setListing((l) => ({
            ...l,
            yardArea: e.target.value === "" ? null : Number(e.target.value),
          }))
        }
      />
    </label>
  </div>
)}




      {/* PROJECT TYPES */}
      {showProjectTypes && (
        <>
          <h3>{t("project_type")}</h3>

          <div className="option-grid">
            {PROJECT_TYPES.map((p) => (
           <button
  key={p}
  className={`option-card ${
    listing.projectType === p ? "active primary" : ""
  }`}
  onClick={() =>
    setListing((l) => ({
      ...l,
      projectType: p,
    }))
  }
>
  {t(p)}
     </button>
            ))}
          </div>
        </>
      )}


      <StepNavigation
     onBack={onBack}
     onNext={handleNext}
     nextDisabled={isNextDisabled}
    />
    </div>
  );
}
